<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ "input-model" | translate }}</mat-label
      ><input
        type="text"
        matInput
        formControlName="model"
        [matAutocomplete]="auto"
        [required]="required"
      />
      <mat-autocomplete
        autoActiveFirstOption
        #auto="matAutocomplete"
        [displayWith]="displayFn.bind(this)"
      >
        <mat-option
          *ngFor="let currentModel of models"
          (onSelectionChange)="onModelSelected($event, currentModel)"
          [value]="currentModel"
        >
          {{ currentModel.model }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="modelControl.hasError('required')">
        {{ requiredText || "required-model" | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</form>
